export default __webpack_public_path__ + "static/image3-9c8f62019eba1a40d873e09dafbc5ab7.gif";